import { NvPillModule } from './../../../../nvps-libraries/design/nv-pill/nv-pill.module';
import { InfoBoxComponent } from './info-box.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [InfoBoxComponent],
  imports: [CommonModule, NvPillModule],
  exports: [InfoBoxComponent],
  providers: [],
})
export class InfoBoxModule {}
